import { Link } from "react-router-dom";
import { Users, IdCard, ShieldCheck, Building2, Landmark, TrendingUp, HeartHandshake, Store, Receipt, Wallet, ChevronLeft, ChevronRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal, ChapterTag } from "./Reveal";
import { SERVICES } from "@/data/servicesData";

const icons = [Users, IdCard, ShieldCheck, Building2, Landmark, TrendingUp, HeartHandshake, Store, Receipt, Wallet];
const spans = ["md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-6", "md:col-span-6", "md:col-span-4", "md:col-span-4", "md:col-span-4", "md:col-span-6", "md:col-span-6"];

export default function Services() {
  const { t, dir } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative max-w-7xl mx-auto px-6 lg:px-10 py-24 md:py-32">
      <Reveal>
        <ChapterTag num="01" label={t("ch_services")} />
        <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-3xl">{t("services_title")}</h2>
        <p className="mt-4 text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">{t("services_sub")}</p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-6">
        {t("services").map((s, i) => {
          const Icon = icons[i];
          const Chevron = dir === "rtl" ? ChevronLeft : ChevronRight;
          return (
            <Reveal key={s.name} delay={i * 0.06} className={spans[i]}>
              <Link to={`/services/${SERVICES[i].slug}`}
                data-testid={`service-card-${i}`}
                className="group block h-full glass rounded-2xl p-7 transition-[transform,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl bg-gold/10 border border-gold/25 flex items-center justify-center text-gold mb-5 transition-transform duration-300 group-hover:scale-110">
                    <Icon size={22} />
                  </div>
                  <Chevron size={18} className="text-white/25 transition-all duration-300 group-hover:text-gold rtl:group-hover:-translate-x-1 ltr:group-hover:translate-x-1" />
                </div>
                <h3 className="font-display font-bold text-xl md:text-2xl">{s.name}</h3>
                <p className="mt-2 text-sm md:text-base text-white/55 leading-relaxed">{s.desc}</p>
              </Link>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
